/* eslint-disable react/no-danger */
import { Icon } from '@iconify/react';

const PricingCard = ({ type, title, seats, features, description, additionalContent, ctaLink }) => (
  <div className="bg-white shadow-[0_0_15px_0_rgba(188, 188, 188, 0.39)] rounded-[20px] p-5 flex flex-col gap-5">
    <div className="flex flex-col gap-2.5">
      <div className="flex flex-col xl:flex-row gap-2.5 xl:justify-between xl:items-center">
        <div>
          <p className="font-[600] text-lg text-[#295BF6]">{title}</p>
          <p className="text-xs text-[#888888]">{seats}</p>
        </div>

        <button
          className="flex justify-center gap-[5px] items-center px-2.5 py-[5px] bg-[#00A925] rounded-[20px] shadow-[0_4px_4px_0_rgba(0,0,0,0.25)]"
          onClick={() => window.open(ctaLink)}
        >
          <Icon icon="hugeicons:question" width={20} color="white" />

          <p className="text-xs xl:text-[10px] font-medium text-white">Tanya Produk</p>
        </button>
      </div>

      <p className="text-[8px] text-[#3066D2] text-center">{description}</p>

      <div className="h-[1px] w-full bg-gradient-to-r from-[rgba(41,91,246,0.8)] to-[rgba(41,91,246,0.2)]" />
    </div>

    <div className="grow flex flex-col justify-between gap-5">
      <ul className="">
        {features.map((feature, index) => (
          <li key={index} className="flex items-center gap-2.5">
            <Icon
              icon="solar:check-read-line-duotone"
              width={24}
              color="#3066D2"
              className="shrink-0"
            />

            <p
              className="text-xs"
              dangerouslySetInnerHTML={{
                __html: feature,
              }}
            />
          </li>
        ))}
      </ul>

      {additionalContent && (
        <div
          dangerouslySetInnerHTML={{
            __html: additionalContent,
          }}
        />
      )}
    </div>
  </div>
);

export default PricingCard;
